export const comparisonsData = [
  {
    id: "chatgpt-vs-claude",
    category: "LLM & Chat",
    toolA: {
      name: "ChatGPT (GPT-4o)",
      developer: "OpenAI",
      pricing: "Freemium ($20/mo)",
      accuracy: "9.2/10",
      bestFor: "Creative writing, general knowledge, custom integrations",
      limitations: "Strict safety filters, occasionally repeats patterns"
    },
    toolB: {
      name: "Claude 3.5 Sonnet",
      developer: "Anthropic",
      pricing: "Freemium ($20/mo)",
      accuracy: "9.5/10",
      bestFor: "Coding, complex logical reasoning, academic analysis",
      limitations: "Strict query limits even on premium tiers"
    }
  },
  {
    id: "midjourney-vs-dalle",
    category: "Image Generation",
    toolA: {
      name: "Midjourney v6",
      developer: "Midjourney Inc.",
      pricing: "Paid ($10/mo min)",
      accuracy: "9.8/10",
      bestFor: "Photorealism, artistic textures, complex lighting",
      limitations: "Requires Discord integration, steep prompt learning curve"
    },
    toolB: {
      name: "DALL-E 3",
      developer: "OpenAI",
      pricing: "Included in GPT Plus",
      accuracy: "9.0/10",
      bestFor: "Text rendering, strict prompt adherence, simplicity",
      limitations: "Can look overly 'synthetic' or cartoonish"
    }
  },
  {
    id: "elevenlabs-vs-speechify",
    category: "Audio & Speech",
    toolA: {
      name: "ElevenLabs",
      developer: "ElevenLabs",
      pricing: "Freemium ($5/mo avg)",
      accuracy: "9.6/10",
      bestFor: "Voice cloning, cinematic narration, emotion mapping",
      limitations: "Character limit constraints on free tiers"
    },
    toolB: {
      name: "Speechify",
      developer: "Speechify",
      pricing: "Paid ($139/yr)",
      accuracy: "8.9/10",
      bestFor: "Text-to-speech for reading documents, multitasking",
      limitations: "Fewer emotional modulation options"
    }
  },
  {
    id: "copilot-vs-cursor",
    category: "Coding Assistants",
    toolA: {
      name: "GitHub Copilot",
      developer: "Microsoft/GitHub",
      pricing: "Paid ($10/mo)",
      accuracy: "9.1/10",
      bestFor: "Inline autocomplete, wide ecosystem adoption, seamless IDE integration",
      limitations: "Struggles with full codebase understanding without context"
    },
    toolB: {
      name: "Cursor AI",
      developer: "Anysphere",
      pricing: "Freemium ($20/mo)",
      accuracy: "9.7/10",
      bestFor: "Codebase-wide refactoring, multi-file edits, natural language debugging",
      limitations: "Requires migrating to a fork of VS Code"
    }
  },
  {
    id: "jasper-vs-copyai",
    category: "Copywriting & SEO",
    toolA: {
      name: "Jasper",
      developer: "Jasper AI",
      pricing: "Paid ($39/mo)",
      accuracy: "8.8/10",
      bestFor: "Enterprise brand voice, collaborative marketing campaigns",
      limitations: "Steep pricing relative to standard LLM endpoints"
    },
    toolB: {
      name: "Copy.ai",
      developer: "Copy.ai",
      pricing: "Freemium ($36/mo)",
      accuracy: "8.7/10",
      bestFor: "Sales funnels, automated workflows, quick copy variants",
      limitations: "Content can require heavy editing for depth"
    }
  }
];
